<div>
  <div (click)="toggleIsOpened()"
       role="button">
    @switch (commandProgress().status) {
      @case ('Acknowledged') {
        <span class="fa-li">
          <fa-icon [icon]="['fas', 'check-circle']"
                   [class]="['text-success', 'bg-white']"></fa-icon>
        </span>
      }
      @case ('Error') {
        <span class="fa-li">
          <fa-icon [icon]="['fas', 'times-circle']"
                   [class]="['text-danger', 'bg-white']"></fa-icon>
        </span>
      }
      @case ('CommandFormatError') {
        <span class="fa-li">
          <fa-icon [icon]="['fas', 'times-circle']"
                   [class]="['text-danger', 'bg-white']"></fa-icon>
        </span>
      }
      @case ('NotNow') {
        <span class="fa-li">
          <fa-icon [icon]="['fas', 'pause-circle']"
                   [class]="['text-warning', 'bg-white']"></fa-icon>
        </span>
      }
      @default {
        <span class="fa-li">
          <fa-icon [icon]="['far', 'circle']"
                   [class]="['text-primary', 'bg-white']"></fa-icon>
        </span>
      }
    }
    <h6 class="text-primary">{{ commandProgress().requestType }}</h6>
    <p>
      {{ commandProgress().created | date: 'short' }}
    </p>
  </div>
  @if (isOpened) {
    <ml-timeline-command [commandContent]="commandContent()"></ml-timeline-command>
  }
</div>